import { useCallback } from 'react';
import { useSetPrimaryDepotContactMutation } from 'pages/Management/Depot/ContactsTab/hooks/useSetPrimaryDepotContactMutation';
import { type ContactDepot } from '../EditContactModal/DepotSelector';
import useAddContactToDepotMutation from '../EditContactModal/hooks/useAddContactToDepotMutation';

const useAddDepotsToContact = () => {
  const [addContactToDepot] = useAddContactToDepotMutation();
  const [setPrimaryDepotContact] = useSetPrimaryDepotContactMutation({
    refetchQueries: [
      'ManagedPlatformAccountContacts',
      'DepotContacts',
      'ActivityLogs',
    ],
  });

  const addDepotsToContact = useCallback(
    async (
      contactId: string,
      depots: ContactDepot[],
      primaryDepotIds: string[] = [],
    ) => {
      const errors: string[] = [];

      await Promise.all(
        depots.map(async (d) => {
          try {
            await addContactToDepot({
              variables: {
                contactId,
                depotId: d.id,
              },
            });

            if (primaryDepotIds.includes(d.id)) {
              try {
                await setPrimaryDepotContact({
                  variables: {
                    depotId: d.id,
                    globalContactId: contactId,
                  },
                });
              } catch {
                // Primary assignment failures are non-blocking
              }
            }
          } catch {
            errors.push(d.name ?? /* istanbul ignore next -- @preserve */ d.id);
          }
        }),
      );

      return errors;
    },
    [addContactToDepot, setPrimaryDepotContact],
  );

  return addDepotsToContact;
};

export default useAddDepotsToContact;
